import React, {useState, useEffect} from "react";
import {SetMetaData} from './../../helper/page-title';
import moment from 'moment';
import ValidationHelper from "../../helper/validation";
import {post_api_call,
        error_api_call,
        get_api_call_main,
        post_api_call_main
      } from './../../actions/action-creators/common';
import { alertResponseMessage } from "../../actions/action-creators/response";
//Modal
import ModalMaster from "../../modal/master";
import ModalMasterDetail from "../../modal/master-detail";
// import FormDataHub from "../../data/formData/hub";
import PinTopModal from "../../modal/student/pin-top";
// const {
//     //Hub
//     fieldHub,
//     fieldValuesHub,
//     fieldValidationHub,
//     fieldHubView
// } = FormDataHub;
const oppModes = [
  {id:  1, label: 'Online'},
  {id:  2, label: 'Physical'},
  {id:  3, label: 'Hybrid'}
];
// const oppIsReserved =  [
//   {id:  1, label: 'Yes'},
//   {id:  2, label: 'No'}
// ];
const oppCurrencyType = [
  {id:  1, label: '₹'},
  {id:  2, label: '$'}
];
function StuPinnedList(){
    SetMetaData("Manage Pinned Students", "", "");
    const [isLoading, setIsLoading] = useState(true);
    const [modalLoader, setModalLoader] = useState({add_edit: false});
    const [modalToggle, setModalToggle] = useState({add_edit: false});
    const [masterTableData, setMasterTableData] = useState([]);
    const [pinnedModalData, setPinnedModData] = useState({});
    const [masterFieldData, setMasterFieldData] = useState([]);
    const [activeEditForm, setActiveForm] = useState("");
    // const [formDataMaster, setFormMasterData] = useState([]);
    const [errorData, setErrorData] = useState({add_edit: []});
    const [formNewData, setNewFormData] = useState({});
    const [formEditData, setEditFormData] = useState({});
    const [formUpdatedData, setUpdatedFormData] = useState({});
    const [isProcess, setIsProcess] = useState({new: false, edit: false});
    //Single Details
    // const [isBtnDisabled, setBtnDisabled] = useState({new: true, edit: true});
    //Options Data
    const [oppTypeOpt, setOppTypeOpt] = useState([]);
    //Get Data for Dropdown
    const fetchMasterList = async() => {
      try{
        const oppoApiData = await post_api_call('pinned-students', {});
        if(oppoApiData.status === 200){
          setMasterTableData(oppoApiData.data);
          setIsLoading(false);
        }
      }catch(e){
        error_api_call({error: `admin|student|list-pinned|fetchMasterList|${e}`});
      }
    }
    useEffect(() => {
      //Initial API Data
      fetchMasterList();
    }, []);
    //View Data
    const toggleModal = async(e, modal_type, toggleState, data={}) => {
        try{
            if(toggleState){
                e.preventDefault();
            }
            if(toggleState){
                switch (modal_type) {
                    case 'add_edit':
                      setPinnedModData(data ? {...data} : {title: '', user_id: ''});
                        break;
                    // case 'edit':
                    //     setMasterFieldData([{form_type: 'edit', label: legendTitle, fields: [...fieldHub]}]);
                    //     break;
                    default: 
                        break;
                }
                // setErrorData({...errorData, [form_type]: []});
                // setActiveForm(form_type);
            }
            setModalToggle({...modalToggle, [modal_type]: toggleState});
        }catch(error){
            console.log(error)
        }
    }
    //Approve Toggle
    const approveToggle = async(e, type, is_active, pin_stu_id) => {
        e.preventDefault();
        try{
          // status_change
          // if (window.confirm(`${is_active === 1 ? 'Inactive' : 'Activate'} Opportunity?`)){
            const targetTag = e.target.tagName.toLowerCase();
            if(targetTag === 'i'){
                e.target.parentElement.disabled = true;
            }else{
                e.target.disabled = true;
            }
            const statusApiData = await post_api_call(`pin-student/add-update`, {pin_stu_id: pin_stu_id,
                                                                                active_status_id: is_active === 2 ? 1 : 2});
            if(statusApiData.status === 200){
                fetchMasterList();
                alertResponseMessage({alert_type: 1, message: `${is_active === 1 ? 'Deactivated' : 'Activated'} Successfully!`});
            }
            if(targetTag === 'i'){
                e.target.parentElement.disabled = false;
            }else{
                e.target.disabled = false;
            }
          // }
        }catch(e){
            const targetTag = e.target.tagName.toLowerCase();
            if(targetTag === 'i'){
                e.target.parentElement.disabled = false;
            }else{
                e.target.disabled = false;
            }
          error_api_call({error: `admin|student|list-pinned|approveToggle|${e}`});
        }
    }

    return (
        <>
        <div className="row">
            <div className="col-lg-12 text-end">
                <button className="btn btn-info mb-2" onClick={(e) => toggleModal(e, 'add_edit', true, null)}>Add Student</button>
            </div>
              <div className="col-lg-12 grid-margin stretch-card">
                <div className="card">
                  <div className="card-body table-responsive sticky-table">
                    {/* <h4 className="card-title">Basic Table</h4> */}
                    {/* <p className="card-description"> Add class <code>.table</code></p> */}
                    <table className="table">
                      <thead>
                        <tr>
                          <th>User Id</th>
                          <th className="w-200p">Title</th>
                          <th>Name</th>
                          <th>Created Date<br/>(DD/MM/YYYY)</th>
                          <th>Status</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {isLoading
                        ? 
                        <tr className="text-center"><td colSpan={8}><div className="p-4"><img alt="Loader" src={require('../../assets/images/Image-Loader.gif')} /></div></td></tr>
                        :
                        <>
                        {masterTableData.map((data, data_index) => (
                          <tr key={`tableData_${data_index}`}>
                            <td>{data.user_id}</td>
                            <td>{data.top_deck_title}</td>
                            <td>{data.first_name} {data.last_name || ''}</td>
                            <td>{moment(data.created_at).format("DD/MM/yyyy")}</td>
                            <td><label className={`badge ${data.status === 'Active' ? 'badge-success' : 'badge-danger'}`}>{data.status}</label></td>
                            <td>
                              {/* <button onClick={(e) => toggleModal(e, 'detail', data.id)} className="btn btn-sm btn-twitter" title="View Data"><i className="mdi mdi-eye"></i></button> */}
                              <button onClick={(e) => approveToggle(e, 'status_change', data.active_status_id, data.pin_stu_id)} className={`btn btn-sm ms-2 ${data.active_status_id === 1 ? 'btn-danger' : 'btn-success'}`} title="Activate/Inactive"><i className="mdi mdi-check-outline"></i></button>
                              <button onClick={(e) => toggleModal(e, 'add_edit', true, data)} className={`btn btn-sm ms-2 btn-facebook`} title="Edit Data"><i className="mdi mdi-pencil"></i></button>
                            </td>
                          </tr>
                        ))}
                        </>
                        }
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
        </div>
        {/* Add-Edit Entry */}
        <PinTopModal
          isShow={modalToggle.add_edit}
          // loader={modalLoader.edit}
          _toggleModal={(e, state) => toggleModal(e, 'add_edit', state)}
          data={pinnedModalData}
          modal_type={'main'}
          _afterUpdate={() => fetchMasterList()}
        />
        </>
    )    
}

export default StuPinnedList;